export const IarMemberEnum = {
  userType: 'userType',
  isMarketingCustomSectionEnabled: 'isMarketingCustomSectionEnabled',
  memberId: 'memberId',
  isResidentialPlansApproved: 'isResidentialPlansApproved',
  isCommunityAppEnabled: 'isCommunityAppEnabled',
  isCommunityAppAlert: 'isCommunityAppAlert',
  identifier: 'identifier',
  fullName: 'fullName',
  fireDepartmentIdentifier: 'fireDepartmentIdentifier',
  fireDepartmentId: 'fireDepartmentId',
  email: 'email',
  allowEditOwnProfile: 'allowEditOwnProfile'
}

export const UserTypeEnum = {
  Administrator: 'Administrator',
  Member: 'Member'
}
